import { useTranslation } from "react-i18next";
import DialogForm from "../../../shared/components/DialogForm";
import {
  Button,
  FormControl,
  Grid,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import {
  SendEmail,
  SendMessage,
} from "../../../shared/validations/AdminValidator";
import PhoneInput from "react-phone-input-2";
import { ErrorMessage, Field, Formik } from "formik";
import ShowInputError from "../../../shared/components/ShowInputError";
import FormikInput1 from "../../../shared/material-ui-formik/FormikInput1";
import JoditEditor from "jodit-react";
import { useEffect, useRef, useState } from "react";

export const SendSmsDialog = (propsDia) => {
  const { t } = useTranslation();

  const editor = useRef();

  let {
    openSendSmsDialog,
    handleChangeSmsDialog,
    handleSendAgreement,
    selectDetail,
    handleSendFolioReceipt,
    smsInitialValue,
    handleSendSms,
    setSmsInitialValue,
    handleSendAgreementEmail,
    handleSendFolioReceiptEmail,
    emailInitialValue,
    handleSendEmail,
    smsUserDetail,
    setEmailInitialValue,
  } = propsDia;

  const [userSelected, setUserSelected] = useState(0);

  const handleUserSelect = (e) => {
    const { value } = e.target;
    if (value !== 0) {
      setUserSelected(value);
      let userDataSelected = smsUserDetail?.find((item) => item?.id === value);
      setSmsInitialValue((prevState) => ({
        ...prevState,
        phone_code: userDataSelected?.phone_code,
        phone_number: userDataSelected?.mobile,
      }));
      setEmailInitialValue((prevState) => ({
        ...prevState,
        email: userDataSelected?.email,
      }));
    }
  };

  useEffect(() => {
    setUserSelected(smsUserDetail?.[0]?.id);
  }, [smsUserDetail]);

  return (
    <DialogForm
      scroll="paper"
      maxWidth="md"
      // maxWidth="mb"
      title={t("Send SMS")}
      openDialog={openSendSmsDialog}
      handleDialogClose={handleChangeSmsDialog}
      disableAutoFocus={true}
      disableEnforceFocus={true}
      bodyContent={
        <>
          {smsUserDetail?.length > 0 && (
            <>
              <div className="p-2">
                <FormControl fullWidth>
                  <Typography
                    id="font-600"
                    style={{
                      marginBottom: "11px",
                      color: "rgb(30, 30, 30)",
                      fontSize: "16px",
                      lineHeight: "24px",
                      fontWeight: "500 !important",
                    }}
                  >
                    {t("Select User")}:
                  </Typography>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={userSelected}
                    onChange={handleUserSelect}
                  >
                    <MenuItem value={0}>{t("Select User")}</MenuItem>
                    {smsUserDetail?.map((data) => (
                      <MenuItem key={data?.id} value={data?.id}>
                        {data?.name} - {data?.phone_code + data?.mobile}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  // marginRight: "-90px",
                  borderTop: "2px solid black",
                }}
              ></div>
            </>
          )}
          <div className="p-2">
            <div className="d-flex">
              <Button
                // type="submit"
                className="mt-1 mb-1 comman-button"
                size="large"
                variant="contained"
                disableElevation
                color="primary"
                onClick={handleSendAgreement}
                // style={{
                //   justifyContent: "center",
                //   width: "fit-content",
                //   height: "44px",
                //   textTransform: "capitalize",
                //   background:
                //     "linear-gradient(180deg, #255480 0%, #173450 100%)",
                // }}
              >
                {t("Send Agreement")}
              </Button>
              {selectDetail?.booking_status === 4 && (
                <Button
                  // type="submit"
                  className="mt-1 mb-1 mx-2 comman-button"
                  size="large"
                  variant="contained"
                  disableElevation
                  color="primary"
                  onClick={handleSendFolioReceipt}
                >
                  {t("Send Receipt")}
                </Button>
              )}
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              // marginRight: "-90px",
              borderTop: "2px solid black",
            }}
          ></div>
          <div className="p-2">
            <Typography
              id="font-600"
              style={{
                marginBottom: "11px",
                color: "rgb(30, 30, 30)",
                fontSize: "16px",
                lineHeight: "24px",
              }}
            >
              {t("Phone")}
            </Typography>

            <Grid container spacing={2} alignItems="flex-start">
              <Formik
                initialValues={smsInitialValue}
                onSubmit={(values, { resetForm }) => {
                  handleSendSms(values);
                  resetForm({ ...values, sms: "" });
                }}
                validateOnBlur={true}
                validateOnChange={true}
                enableReinitialize={true}
                validationSchema={() => SendMessage(t)}
              >
                {(props) => {
                  const { handleSubmit } = props;
                  return (
                    <form
                      onSubmit={handleSubmit}
                      className="p-2"
                      style={{ width: "100%" }}
                      noValidate
                    >
                      <Grid container spacing={2} alignItems="flex-start">
                        <Grid item lg={4} md={4} sm={4} xs={6}>
                          <PhoneInput
                            country={"us"}
                            enableSearch={true}
                            value={smsInitialValue.phone_code}
                            onChange={(phone, countryData) => {
                              setSmsInitialValue((prevState) => ({
                                ...prevState,
                                phone_code: `+${countryData?.dialCode}`,
                              }));
                            }}
                            specialLabel=""
                            inputStyle={{
                              width: "100%",
                              border: "1px solid #B4ADAD !important",
                              borderRadius: "6px !important",
                              height: "50px",
                            }}
                          />
                        </Grid>
                        <Grid item lg={8} md={8} sm={8} xs={6}>
                          <FormControl fullWidth>
                            <Field
                              style={{ width: "100%", top: "-4px" }}
                              name="phone_number"
                              type="number"
                              placeHolder={t("Phone")}
                              maxLength={150}
                              component={FormikInput1}
                            />
                            <ErrorMessage
                              name="phone"
                              component={ShowInputError}
                            />
                          </FormControl>
                        </Grid>

                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Typography
                            id="font-600"
                            style={{
                              marginBottom: "11px",
                              color: "rgb(30, 30, 30)",
                              fontSize: "16px",
                              lineHeight: "24px",
                            }}
                          >
                            {t("Message")}
                          </Typography>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Field
                            name="sms"
                            // minRows={5}
                            rows={5}
                            as="textarea"
                            placeholder={t("Message")}
                            style={{ borderRadius: "8px", padding: "10px" }}
                            className="form-textarea w-100"
                          />
                          <ErrorMessage name="sms" component={ShowInputError} />
                        </Grid>

                        <Grid item lg={12} md={12}>
                          <Button
                            type="submit"
                            className="mt-1 comman-button"
                            size="large"
                            variant="contained"
                            disableElevation
                            color="primary"
                          >
                            {t("Send SMS")}
                          </Button>
                        </Grid>
                      </Grid>
                    </form>
                  );
                }}
              </Formik>
            </Grid>
            {/* </Formik> */}
          </div>
          <div
            id="green-back"
            style={{
              fontSize: "1.066rem",
              // background: "#1C3A66",
              padding: "12px 16px",
              // color: "#FFFFFF",
            }}
          >
            {" "}
            {t("Send Email")}
          </div>
          <>
            <div className="p-2">
              <div className="d-flex">
                <Button
                  // type="submit"
                  className="mt-1 mb-1 comman-button"
                  size="large"
                  variant="contained"
                  disableElevation
                  color="primary"
                  onClick={handleSendAgreementEmail}
                >
                  {t("Send Agreement")}
                </Button>
                {selectDetail?.booking_status === 4 && (
                  <Button
                    // type="submit"
                    className="mt-1 mb-1 mx-2 comman-button"
                    size="large"
                    variant="contained"
                    disableElevation
                    color="primary"
                    onClick={handleSendFolioReceiptEmail}
                  >
                    {t("Send Receipt")}
                  </Button>
                )}
              </div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                // marginRight: "-90px",
                borderTop: "2px solid black",
              }}
            ></div>
          </>
          <div className="p-2">
            <Grid container spacing={2} alignItems="flex-start">
              <Formik
                initialValues={emailInitialValue}
                onSubmit={(values, { resetForm }) => {
                  handleSendEmail(values);
                  resetForm({ ...values, body: "", subject: "" });
                }}
                validateOnBlur={true}
                validateOnChange={true}
                enableReinitialize={true}
                validationSchema={() => SendEmail(t)}
                // disableEnforceFocus={true}
              >
                {(props) => {
                  const { handleSubmit, values } = props;
                  return (
                    <form
                      onSubmit={handleSubmit}
                      className="p-2"
                      style={{ width: "100%" }}
                      noValidate
                    >
                      <Grid item lg={12} md={12}>
                        <Field
                          label={t("Email")}
                          type="email"
                          name="email"
                          className="mb-3"
                          placeHolder={t("Email")}
                          maxLength={150}
                          component={FormikInput1}
                        />
                        <ErrorMessage name="email" component={ShowInputError} />
                      </Grid>
                      <Grid item lg={12} md={12} className="mb-3">
                        <Field
                          label={t("Subject")}
                          type="text"
                          name="subject"
                          placeHolder={t("Subject")}
                          maxLength={150}
                          component={FormikInput1}
                        />
                        <ErrorMessage
                          name="subject"
                          component={ShowInputError}
                        />
                      </Grid>

                      <Grid item lg={12} md={12}>
                        <Typography
                          id="font-600"
                          style={{
                            marginBottom: "11px",
                            color: "rgb(30, 30, 30)",
                            fontSize: "16px",
                            lineHeight: "24px",
                          }}
                        >
                          {t("Message")}
                        </Typography>
                      </Grid>
                      <Grid item lg={12} md={12}>

                        <Field name="body">
                          {({ field, meta }) => (
                          
                            <JoditEditor
                              ref={editor}
                              value={values?.body}
                              onChange={(e) => {
                                props?.setFieldValue("body", e);
                              }}
                              placeHolder={t("Start Writing")}
                            />
                          )}
                        </Field>
                        <ErrorMessage name="body" component={ShowInputError} />
                      </Grid>
                      <Grid item lg={12} className="mt-2" md={12}>
                        <Button
                          className="mt-1 comman-button"
                          size="large"
                          type="submit"
                          variant="contained"
                          disableElevation
                          color="primary"
                        >
                          {t("Send Email")}
                        </Button>
                      </Grid>
                    </form>
                  );
                }}
              </Formik>
            </Grid>
          </div>
        </>
      }
    />
  );
};
